import { findRoot } from "./findRoot";

export function mergeChildren(children, type) {
    const root = findRoot(children, type);
    return root ? children.concat(root.props.children) : children;
}
